// src/components/about/HeroSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import pic1 from '../../assets/img14.jpg';

export default function HeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-amber-50 via-[#EBE0CF] to-emerald-50 px-6 md:px-12 lg:px-20 py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid-black/5 pointer-events-none"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <div className="text-center lg:text-left space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
                The Philosophy of
                <br />
                <span className="text-5xl md:text-7xl lg:text-7xl block mt-3 bg-gradient-to-r from-[#0B2A2C] to-emerald-800 bg-clip-text text-transparent">
                  Ayusanjivni
                </span>
              </h1>
            </div>

            <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              At Ayusanjivni, healing is not just treatment — it is transformation. We weave ancient wisdom of 
              <span className="font-medium text-emerald-800"> Yoga, Ayurveda, Panchakarma, and Naturopathy </span>
              into a sacred journey that restores balance to your body, mind, and soul.
            </p>

            <div className="pt-6">
              <Link
                to="/"
                className="inline-flex items-center gap-3 bg-[#0B2A2C] text-white px-10 py-5 rounded-full text-lg font-medium 
                         hover:bg-emerald-900 transform hover:scale-105 transition-all duration-300 shadow-xl"
              >
                Return Home
                <ChevronRight className="w-5 h-5" />
              </Link>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-3xl blur-xl opacity-30 group-hover:opacity-50 transition duration-1000"></div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={pic1}
                alt="Ayusanjivni Sanctuary"
                className="w-full h-[400px] lg:h-[550px] object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}